import { mode } from "@chakra-ui/theme-tools";

const disabledStyles = (props) => {
  return {
    _disabled: {
      bg: mode("darkGray.dark", "darkGray.light")(props),
    },
  };
};
const primaryStyles = (props) => {
  return {
    color: "white",
    bg: mode("primary.700", "primary.600")(props),
    ...disabledStyles(props),
    _hover: {
      bg: mode("primary.600", "primary.500")(props),
      color: "white",
      ...disabledStyles(props),
    },
  };
};

export const buttonStyles = {
  components: {
    Button: {
      defaultProps: {
        size: "xl",
      },
      sizes: {
        xl: {
          h: "80px",
        },
      },
      baseStyle: {
        w: "100%",
        borderRadius: "2xl",
      },
      variants: {
        primary: (props) => ({
          border: "none",
          ...primaryStyles(props),
        }),
        nextStep: (props) => ({
          border: "none",
          w: "130px",
          h: "45px",
          ...primaryStyles(props),
        }),
        rejectStep: (props) => ({
          border: "none",
          w: "130px",
          h: "45px",
          ...primaryStyles(props),
          bg: mode("red.light", "red.dark")(props),
          _hover: {
            bg: mode("red.dark", "red.light")(props),
            color: "white",
          },
        }),
        prevStep: (props) => ({
          border: "none",
          w: "130px",
          h: "45px",
          ...primaryStyles(props),
        }),
        outline: (props) => ({
          color: "red.light",
          bg: "transparent",
          border: "2px solid",
          borderColor: { bg: mode("red.light", "red.dark")(props) },
          ...disabledStyles(props),
          _hover: {
            bg: mode("red.light", "red.dark")(props),
            borderColor: mode("red.light", "red.dark")(props),
            color: "white",
          },
          _focus: { bg: mode("blue.50", "transparent")(props) },
          _active: { bg: mode("blue.50", "transparent")(props) },
        }),
        cancel: (props) => ({
          color: "white",
          bg: mode("red.light", "red.dark")(props),
          border: "none",
          ...disabledStyles(props),
          _hover: {
            bg: mode("red.dark", "red.light")(props),
            color: "white",
          },
        }),
        fab: (props) => ({
          position: "absolute",
          border: "none",
          bottom: 30,
          right: 30,
          w: "70px",
          h: "70px",
          borderRadius: "full",
          ...primaryStyles(props),
        }),
        table: (props) => ({
          h: "46px",
          borderRadius: "xl",
          ...primaryStyles(props),
        }),
      },
    },
  },
};
